<template>
  <div class="modal-media" :class="{'modal-media__open': modal}">
    <div class="modal-media__header shadow-sm">
      <button class="btn text-secondary mr-auto d-md-none" @click="closeModal" title="Fechar"><i class="fas fa-arrow-left" style="font-size: 18px"></i></button>
      <a :href="url" download="imagem-lebot" class="btn text-info" title="Download"><i class="fas fa-arrow-alt-circle-down" style="font-size: 18px"></i></a>
      <button class="btn text-dark d-none d-md-block" @click="closeModal" title="Fechar"><i class="fas fa-times" style="font-size: 18px"></i></button>
    </div>
    <div class="modal__inner" @click="closeModal" v-if="modal">
      <div class="modal-media__container">
        <img :src="url">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalMedia',
  data() {
    return {
      modal: false,
      url: null
    }
  },
  methods: {
    closeModal() {
      document.body.classList.remove("modal-open");
      this.modal = false;
      this.url = null;
    },

    openModal() {
      document.body.classList.add("modal-open");
      this.modal = true;
    }
  },

  created() {
    this.$parent.$on('openModalMedia', (url) => {
      if (url) {
        this.openModal();
        this.url = url;
      }
    });
  }
}
</script>

<style scoped>
.modal-media {
  opacity: 0;
  visibility: hidden;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  text-align: left;
  background: rgba(255,255,255,.9);
  transition: opacity .25s ease;
  z-index: 1090;
}

.modal-media__open {
  opacity: 1;
  visibility: visible;
}

.modal__inner {
  transition: top .25s ease;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  overflow: auto;
  border-radius: 4px;
  padding-bottom: 16px;
}

.modal-media__container {
  height: 100%;
  overflow: auto;
}

.modal-media__header {
  z-index: 1;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  padding: 8px;
  background-color: #ffffff;
}

.modal-media img {
  padding-top: 66px;
  height: 95%;
  width: auto;
  max-width: 90%;
  object-fit: contain;
  display: block;
  margin: auto;
}

@media screen and (max-width: 768px) {
  .modal__inner {
    border-radius: 0;
    box-sizing: border-box;
  }
}
</style>
